<script setup lang="ts">
import { ECheckpointActions } from '@/store/checkpointStore/CheckpointStoreTypes'
import { EStoreModules } from '@/store/storeType'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import {
    BaseDialog,
    FullScreenLoader,
    IconButton,
    PrimaryButton,
    TypographyItem
} from '@rfc/rfc-components-library'
import { ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

type Props = {
    asIcon?: boolean
    data: Partial<CheckpointModel>
}
const props = defineProps<Props>()

type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const open = ref(false)
const loading = ref(false)

const handleConfirm = () => {
    loading.value = true
    store
        ?.dispatch(`${EStoreModules.CHECKPOINT}/${ECheckpointActions.ERASE_DETECTIONS}`, {
            eventId: props.data.event_id,
            checkpointId: props.data.id,
            name: props.data.name
        })
        .then(() => {
            emit('refresh')
            open.value = false
        })
        .finally(() => (loading.value = false))
}

const handleClick = (clickValue: boolean, event?: MouseEvent) => {
    event?.preventDefault()
    event?.stopImmediatePropagation()
    event?.stopPropagation()
    open.value = clickValue
}
</script>

<template>
    <FullScreenLoader :loading="loading" />
    <IconButton
        v-if="asIcon"
        icon="history"
        @click="handleClick(true, $event)"
        :iconProps="{ class: 'hover:rotate-270 duration-500 ease-in-out' }" />
    <PrimaryButton
        v-else
        :label="$t('checkpoint.actions.eraseDetectionsTitle')"
        @click="handleClick(true, $event)"
        class="erase-button" />
    <BaseDialog
        :title="$t('checkpoint.actions.eraseDetectionsTitle')"
        :open="open"
        @confirm="handleConfirm"
        @close="handleClick(false, $event)"
        class="event-checkpoint-component modal-selector-half-width"
        v-bind="$attrs">
        <template #content>
            <TypographyItem :label="$t('checkpoint.actions.eraseDetections')" />
        </template>
    </BaseDialog>
</template>

<style scoped lang="scss">
.erase-button {
    &:hover {
        background-color: $primary;
    }
}
</style>
